
import { useMemo, useState } from "react";

import "../styles/PaymentsTable.css";
const numberFormat = new Intl.NumberFormat("fa-IR");

function formatNumber(value) {
  return numberFormat.format(Number(value) || 0);
}

function formatDate(value) {
  if (!value) return "-";

  const date = new Date(value);

  return Number.isNaN(date.getTime())
    ? "-"
    : date.toLocaleDateString("fa-IR");
}

export default function PaymentsTable({
  payments = [],
  title = "لیست تراکنش ها",
  transactionMode = false,
}) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const pageSize = 8;

  const filteredPayments = useMemo(() => {
    const query = search.trim().toLowerCase();

    return payments.filter((payment) => {
      const transactionNumber =
        payment.system_trace_no ??
        payment.transaction_number ??
        payment.id ??
        "";

      const amount = payment.amount ?? "";

      const date = formatDate(
        payment.created_at ?? payment.payment_date
      );

      return [
        transactionNumber,
        amount,
        date,
        payment.order_id ?? "",
      ].some((value) =>
        String(value).toLowerCase().includes(query)
      );
    });
  }, [payments, search]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredPayments.length / pageSize)
  );

  const currentPage = Math.min(page, totalPages);

  const visiblePayments = filteredPayments.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <section className="payments-report" dir="rtl">
      {/* <h3 className="payments-title">{title}</h3> */}

      <div className="payments-toolbar">
        {/* <button
          type="button"
          className="payments-filter"
          onClick={() => {
            setSearch("");
            setPage(1);
          }}
        >
          فیلتر
        </button> */}

        <label className="payments-search">
          <span>جستجو:</span>
          <input
            type="search"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
              setPage(1);
            }}
          />
        </label>
      </div>

      <div className="payments-table-wrapper">
        <table className="payments-table">
          <thead>
            <tr>
              <th>#</th>
              <th>
                {transactionMode
                  ? "شماره تراکنش"
                  : "شماره تراکنش"}
              </th>
              <th>مبلغ واریزی</th>
              <th>تاریخ واریز</th>
            </tr>
          </thead>

          <tbody>
            {visiblePayments.map((payment, index) => (
              <tr key={payment.id ?? index}>
                <td>
                  {filteredPayments.length -
                    ((currentPage - 1) * pageSize + index)}
                </td>

                <td>
                  {payment.system_trace_no ??
                    payment.transaction_number ??
                    payment.id ??
                    "-"}
                </td>

                <td>
                  <span className="payment-amount">
                    {formatNumber(payment.amount)}
                  </span>
                </td>

                <td>
                  {formatDate(
                    payment.created_at ??
                      payment.payment_date
                  )}
                </td>
              </tr>
            ))}

            {visiblePayments.length === 0 && (
              <tr>
                <td colSpan={4} className="payments-empty">
                  تراکنشی برای نمایش وجود ندارد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="payments-footer">
        <span>
          نمایش {filteredPayments.length === 0
            ? 0
            : (currentPage - 1) * pageSize + 1}
          {" تا "}
          {Math.min(
            currentPage * pageSize,
            filteredPayments.length
          )}
          {" از "}
          {filteredPayments.length} رکورد
        </span>

        <div className="payments-pagination">
          <button
            disabled={currentPage >= totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            بعدی
          </button>

          <span>
            {numberFormat.format(currentPage)}
          </span>

          <button
            disabled={currentPage <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            قبلی
          </button>
        </div>
      </div>
    </section>
  );
}
